export const WIDTH = {
  XL: '1280px',
  LG: '978px',
  MD: '670px',
  SM: '375px',
};
